<template>
  <section
    id="notice"
    :class="['warning text-center', customClass]"
  >
    <span v-html="message" />
  </section>
</template>

<script>
export default {
  props: {
    message: String,
    customClass: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../sass/variables';
  #notice {
    background-color: #d9edf7;
    color: #006cb2;
    padding: 18px 22px;
    height: 50px;

    &.warning {
      background-color: $salesflow-secondary;
      color: #334155;
    }
  }
</style>
